/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide the grams per litre (10 × the w/v percent) by the molecular weight. For example 5% w/v is 50 g/L; for a compound of MW 100 g/mol that is 0.5 M.`)
};

const es_pctsol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divide los gramos por litro (10 × el porcentaje p/v) entre el peso molecular. Por ejemplo, 5% p/v son 50 g/L; para un compuesto con PM 100 g/mol eso es 0.5 M.`)
};

const de_pctsol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen Sie die Gramm pro Liter (10 × der w/v-Prozentsatz) durch das Molekulargewicht. Zum Beispiel entspricht 5% w/v 50 g/L; bei einer Verbindung mit MW 100 g/mol sind das 0,5 M.`)
};

const nl_pctsol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deel het aantal gram per liter (10 × het g/v-percentage) door het molecuulgewicht. Bijvoorbeeld 5% g/v is 50 g/L; voor een verbinding met MW 100 g/mol is dat 0,5 M.`)
};

const fr_pctsol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divisez les grammes par litre (10 × le pourcentage p/v) par la masse moléculaire. Par exemple, 5 % p/v correspond à 50 g/L ; pour un composé de MM 100 g/mol, cela donne 0,5 M.`)
};

const it_pctsol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dividi i grammi per litro (10 × la percentuale p/v) per il peso molecolare. Ad esempio 5% p/v equivale a 50 g/L; per un composto con PM 100 g/mol sono 0,5 M.`)
};

const pt_br2_pctsol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida os gramas por litro (10 × o percentual p/v) pelo peso molecular. Por exemplo, 5% p/v equivale a 50 g/L; para um composto de MM 100 g/mol, isso dá 0,5 M.`)
};

const pt_pctsol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divida os gramas por litro (10 × a percentagem m/v) pela massa molecular. Por exemplo, 5% m/v são 50 g/L; para um composto com MM 100 g/mol isso equivale a 0,5 M.`)
};

const ja_pctsol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1リットルあたりのグラム数 (w/vパーセント × 10) を分子量で割ります。例えば5% w/vは50 g/Lで、分子量100 g/molの化合物では0.5 Mになります。`)
};

const zh_pctsol_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将每升克数（w/v 百分比 × 10）除以分子量。例如 5% w/v 等于 50 g/L；对于分子量为 100 g/mol 的化合物，即为 0.5 M。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_faq_a4", locale)
	if (locale === "en") return en_pctsol_faq_a4(inputs)
	if (locale === "es") return es_pctsol_faq_a4(inputs)
	if (locale === "de") return de_pctsol_faq_a4(inputs)
	if (locale === "nl") return nl_pctsol_faq_a4(inputs)
	if (locale === "fr") return fr_pctsol_faq_a4(inputs)
	if (locale === "it") return it_pctsol_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_faq_a4(inputs)
	if (locale === "pt") return pt_pctsol_faq_a4(inputs)
	if (locale === "ja") return ja_pctsol_faq_a4(inputs)
	return zh_pctsol_faq_a4(inputs)
};